import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=482ebd4a&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=482ebd4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482ebd4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('482ebd4a')) {
      api.createRecord('482ebd4a', component.options)
    } else {
      api.reload('482ebd4a', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=482ebd4a&scoped=true&", function () {
      api.rerender('482ebd4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2iCve5ibT4ycf/JS/comp/PopupBox.vue"
export default component.exports